module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "goods"
  }, [_c('img', {
    staticClass: "goods-img",
    attrs: {
      "src": _vm.row.pic_url,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-detail"
  }, [_c('div', {
    staticClass: "goods-name"
  }, [_vm._v(_vm._s(_vm.row.title))]), _vm._v(" "), _c('div', {
    staticClass: "goods-num"
  }, [_vm._v("仅剩"), _c('span', [_vm._v(_vm._s(_vm.order.total_member_count - _vm.order.member_count))]), _vm._v("个名额")]), _vm._v(" "), _c('div', {
    staticClass: "price-box"
  }, [_c('div', {
    staticClass: "goods-price"
  }, [_c('span', [_vm._v("¥")]), _vm._v(_vm._s(_vm.row.price) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "goods-pri-thr gray-light"
  }, [_vm._v("\n          ¥" + _vm._s(_vm.row.goods_price) + "\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "border-top invite"
  }, [(_vm.order.status == 1) ? _c('div', {
    staticClass: "invite-user"
  }, [_vm._l((_vm.member_list), function(item, index) {
    return _c('div', {
      staticClass: "invite-user-box"
    }, [_c('img', {
      staticClass: "user-img",
      attrs: {
        "src": item.face,
        "alt": ""
      }
    }), _vm._v(" "), (item.is_leader > 0) ? _c('span', {
      staticClass: "user-tip"
    }, [_vm._v("团长")]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "user-empity"
  }, [_vm._v("\n        ?\n      ")])], 2) : _vm._e(), _vm._v(" "), (_vm.is_joined) ? _c('div', [(_vm.order.status == 1) ? _c('div', {
    staticClass: "djs-box",
    on: {
      "click": _vm.goShare
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', [_vm._v("邀请好友")]), _vm._v(" "), _c('van-count-down', {
    attrs: {
      "time": (_vm.order.last_time + 1) * 1000
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(timeData) {
        return [_c('span', {
          staticClass: "item"
        }, [_vm._v(_vm._s(timeData.days))]), _vm._v("天\n              "), _c('span', {
          staticClass: "item"
        }, [_vm._v(_vm._s(timeData.hours))]), _vm._v(" :\n              "), _c('span', {
          staticClass: "item"
        }, [_vm._v(_vm._s(timeData.minutes))]), _vm._v(" :\n              "), _c('span', {
          staticClass: "item"
        }, [_vm._v(_vm._s(timeData.seconds))])]
      }
    }], null, false, 2450568742)
  }), _vm._v(" "), _c('div', [_vm._v("结束")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.order.status == 1) ? _c('div', {
    staticClass: "share-text gray-light"
  }, [_vm._v("分享给微信好友，成团高达98%")]) : (_vm.order.status == 2) ? _c('div', {
    staticClass: "share-text gray-light"
  }, [_vm._v("\n        已完成\n        "), _c('div', {
    staticClass: "invite-btn",
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v("返回首页")])]) : (_vm.order.status == 3) ? _c('div', {
    staticClass: "share-text gray-light"
  }, [_vm._v("\n        已过期\n        "), _c('div', {
    staticClass: "invite-btn",
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v("返回首页")])]) : (_vm.order.status == 4) ? _c('div', {
    staticClass: "share-text gray-light"
  }, [_vm._v("\n        未支付\n        "), _c('div', {
    staticClass: "invite-btn",
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v("返回首页")])]) : _vm._e()]) : _c('div', [(_vm.order.status == 1) ? _c('div', {
    staticClass: "djs-box",
    on: {
      "click": _vm.skuSelect
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', [_vm._v("我要参加")]), _vm._v(" "), _c('van-count-down', {
    attrs: {
      "time": (_vm.order.last_time + 1) * 1000
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(timeData) {
        return [_c('span', {
          staticClass: "item"
        }, [_vm._v(_vm._s(timeData.days))]), _vm._v("天\n              "), _c('span', {
          staticClass: "item"
        }, [_vm._v(_vm._s(timeData.hours))]), _vm._v(" :\n              "), _c('span', {
          staticClass: "item"
        }, [_vm._v(_vm._s(timeData.minutes))]), _vm._v(" :\n              "), _c('span', {
          staticClass: "item"
        }, [_vm._v(_vm._s(timeData.seconds))])]
      }
    }], null, false, 2450568742)
  }), _vm._v(" "), _c('div', [_vm._v("结束")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.order.status == 1) ? _c('div', {
    staticClass: "share-text gray-light"
  }, [_vm._v("参加拼团，享优惠")]) : (_vm.order.status == 2) ? _c('div', {
    staticClass: "share-text gray-light"
  }, [_vm._v("\n        已完成\n        "), _c('div', {
    staticClass: "invite-btn",
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v("返回首页")])]) : (_vm.order.status == 3) ? _c('div', {
    staticClass: "share-text gray-light"
  }, [_vm._v("\n        已过期\n        "), _c('div', {
    staticClass: "invite-btn",
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v("返回首页")])]) : (_vm.order.status == 4) ? _c('div', {
    staticClass: "share-text gray-light"
  }, [_vm._v("\n        未支付\n        "), _c('div', {
    staticClass: "invite-btn",
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v("返回首页")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tips-box border-top"
  }, [_c('div', {
    staticClass: "row-between"
  }, [_c('div', {
    staticClass: "row-left"
  }, [_vm._v("拼团时间")]), _vm._v(" "), _c('div', {
    staticClass: "row-right"
  }, [_vm._v("\n        " + _vm._s(_vm.order.time_start_str) + "\n      ")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "detail-img",
    domProps: {
      "innerHTML": _vm._s(_vm.row.content)
    }
  }), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  }), _vm._v(" "), (_vm.showWxShare) ? _c('div', {
    staticClass: "shareShow",
    on: {
      "click": _vm.cancleShare
    }
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sku-container"
  }, [_c('van-sku', {
    attrs: {
      "sku": _vm.skuData.sku,
      "goods": _vm.skuData.goods,
      "goods-id": _vm.skuData.goods_id,
      "hide-stock": _vm.skuData.hide_stock,
      "close-on-click-overlay": _vm.closeOnClickOverlay,
      "message-config": _vm.messageConfig
    },
    on: {
      "buy-clicked": _vm.toBuy
    },
    scopedSlots: _vm._u([{
      key: "sku-actions",
      fn: function(props) {
        return [_c('div', {
          staticClass: "van-sku-actions"
        }, [_c('van-button', {
          attrs: {
            "square": "",
            "size": "large",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return props.skuEventBus.$emit('sku:buy')
            }
          }
        }, [_vm._v("\n            立即购买\n          ")])], 1)]
      }
    }]),
    model: {
      value: (_vm.showSkuPicker),
      callback: function($$v) {
        _vm.showSkuPicker = $$v
      },
      expression: "showSkuPicker"
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-between no-border"
  }, [_c('div', {
    staticClass: "row-left"
  }, [_vm._v("拼团须知")]), _vm._v(" "), _c('div', {
    staticClass: "row-right"
  }, [_vm._v("\n        ·好友参团 ·人满发货 ·不满退款\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-title"
  }, [_c('div'), _vm._v(" "), _c('span', [_vm._v("商品详情")]), _vm._v(" "), _c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("点击分享给好友")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73d4ce30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/tuan/TuanShare.vue
// module id = 2478
// module chunks = 0